import Env from "../env/Env";
import createAxiosInstance from "../utils/axiosInstance";
import { defaultAPIsResponseType, defaultGraphsGetFiltersType } from "../consts/shared";

const basePath = '/api/graphs/dashboard-2';

const request = createAxiosInstance(`${Env.API_BASE}${basePath}`);

const dashboard2APIsService = {
  basePath,
  fetchMostLeastCompliantUsersData: (params: defaultGraphsGetFiltersType, signal?: AbortSignal): Promise<defaultAPIsResponseType> => {
    return new Promise((resolve, reject) => {
      request
        .get("/most-least-compliant-users", { params, signal })
        .then(({ data }) => {
          resolve({ ...data, ...params });
        })
        .catch((err) => {
          reject(err?.response?.data?.errors || []);
        });
    });
  },

  fetchUsersComplianceTrendData: (params: defaultGraphsGetFiltersType, signal?: AbortSignal): Promise<defaultAPIsResponseType> => {
    return new Promise((resolve, reject) => {
      request
        .get("/users-compliance-trend", { params, signal })
        .then(({ data }) => {
          resolve({ ...data, ...params });
        })
        .catch((err) => {
          reject(err?.response?.data?.errors || []);
        });
    });
  },

  fetchMonthlyActiveUsersData: (params: defaultGraphsGetFiltersType, signal?: AbortSignal): Promise<defaultAPIsResponseType> => {
    return new Promise((resolve, reject) => {
      request
        .get("/monthly-active-users", { params, signal })
        .then(({ data }) => {
          resolve({ ...data, ...params });
        })
        .catch((err) => {
          reject(err?.response?.data?.errors || []);
        });
    });
  },

  fetchUsersActivityData: (params: defaultGraphsGetFiltersType, signal?: AbortSignal): Promise<defaultAPIsResponseType> => {
    return new Promise((resolve, reject) => {
      request
        .get("/users-activity", { params, signal })
        .then(({ data }) => {
          resolve({ ...data, ...params });
        })
        .catch((err) => {
          reject(err?.response?.data?.errors || []);
        });
    });
  },

  fetchUsersWithNoCoursesData: (params: defaultGraphsGetFiltersType, signal?: AbortSignal): Promise<defaultAPIsResponseType> => {
    return new Promise((resolve, reject) => {
      request
        .get("/users-with-no-courses", { params, signal })
        .then(({ data }) => {
          resolve({ ...data, ...params });
        })
        .catch((err) => {
          reject(err?.response?.data?.errors || []);
        });
    });
  },

  fetchUsersByCourseAndCompletionData: (params: defaultGraphsGetFiltersType, signal?: AbortSignal): Promise<defaultAPIsResponseType> => {
    return new Promise((resolve, reject) => {
      request
        .get("/users-by-course-and-completion", { params, signal })
        .then(({ data }) => {
          resolve({ ...data, ...params });
        })
        .catch((err) => {
          reject(err?.response?.data?.errors || []);
        });
    });
  },

  fetchSummaryCardsData: (params: defaultGraphsGetFiltersType, signal?: AbortSignal): Promise<defaultAPIsResponseType> => {
    return new Promise((resolve, reject) => {
      request
        .get("/summary-cards", { params, signal })
        .then(({ data }) => {
          resolve({ ...data, ...params });
        })
        .catch((err) => {
          reject(err?.response?.data?.errors || []);
        });
    });
  },
};

export default dashboard2APIsService;
